// extracted by mini-css-extract-plugin
module.exports = {"Orders":"Orders_Orders__1gvue","Orders__list":"Orders_Orders__list__1ee1C","HistoryCard":"Orders_HistoryCard__3HlAP","HistoryCard__details":"Orders_HistoryCard__details__250rs"};